<template>
  <mock-up-main>
    <div class="wheel-fullscreen-wrapper">
                  <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value.visitName || 'گردونه شانس'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>


      <div class="wheel-container">
        <wheel-component
          :value="value"
          :key="wheelKey"
          :id="id"
          :is-preview="true"
          class="wheel"
          @prize-selected="showWinnerCelebration"
        />
      </div>
      <winner-celebration-popup
        v-model="showWinnerPopup"
        :prize-name="lastPrize.prize.name"
        :reward-value="lastPrize.prize.reward_value"
      />
    </div>
  </mock-up-main>
</template>

<script>
import MockUpMain from "@/view/pages/commercial/components/mockUp.vue";
import WheelComponent from "./WheelComponent.vue";
import WinnerCelebrationPopup from "./WinnerCelebrationPopup.vue";
import UniversalQrModal from "../../../../components/UniversalQrModal.vue";

export default {
  name: "ViewLuckWheel",

  components: { MockUpMain, WheelComponent, WinnerCelebrationPopup, UniversalQrModal },
  props: {
    value: { type: Object, required: true },
    id: { type: [String, Number], default: "preview" },

  qrSvgDataUrl: {
      type: String,
      default: "",
    },

  },
  computed: {
    primaryActionColor() {
      return this.value?.info?.background_color || "#1976D2";
    },
    wheelKey() {
      const prizesStr = this.value?.prizes?.items
        ? JSON.stringify(this.value.prizes.items)
        : "no-prizes";

      const logoStr = this.value?.info?.logo ? this.value.info.logo : "no-logo";

      return `wheel-${logoStr}-${prizesStr}`;
    },
  },
  methods: {
    showWinnerCelebration(prize) {
      this.lastPrize.prize.name = prize.name || "جایزه ویژه";
      this.lastPrize.prize.reward_value =
        prize.reward_text || prize.reward_value || "تبریک! شما برنده شدید";
      this.showWinnerPopup = true;
    },
  },
  data: () => ({
    showWinnerPopup: false,
    showQrDialog: false,
    lastPrize: {
      prize: { name: "", reward_value: "" },
    },
  }),
};
</script>
<style scoped>
.wheel-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;
  box-sizing: border-box;
  background: v-bind("value.info?.background_color");
  border: none;
}
.wheel-fullscreen-wrapper {
  background: v-bind('value.info?.background_color || "#e74c3c"');
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  max-height: 100% !important;
  padding: 0px !important;
  margin: 0px !important;
  z-index: 1;
  border-radius: inherit;
  overflow: hidden;
  border: none;
}

.wheel-container {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  padding: 0px !important;
  margin: 0px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mock-up-main > .v-card,
.mock-up-main > div {
  background: transparent !important;
}
.wheel {
  width: 100%;
  /* transform: scale(clamp(0.75, 0.6 + 0.5vw, 0.94)); */
  transform: scale(0.94);
}

@media screen and (min-width: 1000px) and (max-width: 1264px) {
  .wheel {
    transform: scale(0.75) !important;
  }
}
@media screen and ((min-width: 1264px) or (max-width: 1000px)) {
  .wheel {
    transform: scale(0.95) !important;
  }
}
.qr-floating-btn {
  position: absolute;
  top: 44px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
